import { render, staticRenderFns } from "./CompanyInfo2.vue?vue&type=template&id=4b947942&scoped=true"
import script from "./CompanyInfo2.vue?vue&type=script&lang=js"
export * from "./CompanyInfo2.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo2.vue?vue&type=style&index=0&id=4b947942&prod&scoped=true&lang=scss"
import style1 from "./CompanyInfo2.vue?vue&type=style&index=1&id=4b947942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b947942",
  null
  
)

export default component.exports